export class Sheet {
  id: number
  grade: number
  room_name: string
  name: string
  curriculum_id: number
  subject_name: string
  exec_date: string
  sheet_type: number

  constructor(sheet: any){
    this.id = sheet.id;
    this.grade = sheet.grade;
    this.room_name = sheet.room_name;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.exec_date = sheet.exec_date;
    this.sheet_type = sheet.sheet_type;
  }
}

export class SheetField {
  id: number
  x: number
  y: number
  width: number
  height: number

  constructor(sheetField: any){
    this.id = sheetField.id;
    this.x = sheetField.rim[0];
    this.y = sheetField.rim[1];
    this.width = sheetField.rim[2];
    this.height = sheetField.rim[3];
  }
}

export class Examinee {
  id: number
  student_no_character: string
  student_no: number
  student_name: string
  absent_flg: boolean

  constructor(examinee: any){
    this.id = examinee.id;
    this.student_no_character = examinee.student_no_character;
    this.student_no = examinee.student_no;
    this.student_name = examinee.student_name;
    this.absent_flg = examinee.absent_flg;
  }
}

export class SheetActivityItem {
  ids: number[]
  base64_image: string
  student_id: number
  student_id_cache: number
  
  constructor(sheetActivityItem: any){
    this.ids = sheetActivityItem.ids;
    this.base64_image = sheetActivityItem.base64_image;
    this.student_id = sheetActivityItem.student_id;
    this.student_id_cache = sheetActivityItem.student_id;
  }
}